import React from 'react';
import { Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';
import EntityTabComponent from '../EntityTabComponent';
import { VerticalTabs } from '../../../../components';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

const EntityTabBar = ({ tab, onChangeTab, tabs }) => {
  const {
    tabsWrapper,
    root,
    wrapper,
    selected,
    textColorInherit
  } = useStyles();

  const [t] = useTranslation();

  return (
    <VerticalTabs className={tabsWrapper} onChange={onChangeTab} value={tab}>
      {tabs.map(({ title, overview, tabIndex }) => (
        <Tab
          key={title}
          classes={{ root, wrapper, selected, textColorInherit }}
          label={
            <EntityTabComponent
              title={t(title)}
              selected={tab === tabIndex}
              overview={overview}
            />
          }
          {...a11yProps(0)}
        />
      ))}
    </VerticalTabs>
  );
};

export default EntityTabBar;
